import React, { useState } from "react";
// import { useHistory } from "react-router-dom";

import { Button, Row } from "antd";

// import FaqComponent from "../page/salesManage/FaqComponent";

const ContentHeaderComponent = ({
  title,
  subtitle,
  actionButton,
  breadcrumb,
}) => {
  // let history = useHistory();
  const [orderModal, setOrderModal] = useState(false);
  const orderInformation = [
    {
      title:
        "| 발주확인은 발송 처리 전 주문 및 상품판매 가능여부를 확인하는 절차입니다.",
      content: [
        "• 발송이 가능한 주문만 ‘발주확인’처리를 진행해 주세요.",
        "• 발주확인이 완료 된 주문은 주문상태가 ‘배송준비중’ 으로 변경되고, 구매자에게도 ‘배송준비중’ 상태로 노출 됩니다.",
        "• 구매자가 임의로 주문취소 및 주문정보를 수정 할 수 없습니다",
      ],
    },
    {
      title:
        "| 발송처리는 발주확인 이후 단계입니다. 배송정보를 입력하여 발송완료처리할 수 있습니다.",
      content: [
        "• 배송수단을 이용하여 구매상품을 고객에게 보내는 절차입니다.",
        "• ‘발송처리’가 완료되면, 주문상태는 ‘배송중’으로 변경되고 구매자에게도 ‘배송중’ 상태로 노출 됩니다.",
        "• 직접 리스트에서 선택한 값에 대해 택배사, 송장번호, 발송일을 입력 후 [발송처리]를 눌러주세요.",
        "• 또는 [엑셀 일괄 발송처리]를 통해서 일괄발송처리 양식에 알맞은 엑셀 파일을 업로드하여 발송처리를 완료해주세요.",
        "• 주문상태 ‘배송중’ 이후 배송완료 처리는 배송방법에 따라 아래와 같이 달라집니다.",
      ],
    },
    {
      title: "| 엑셀 일괄 발송처리 안내",
      content: [
        "• 주문 엑셀 다운로드 : [엑셀 일괄 발송처리] 버튼을 클릭 후 ‘일괄발송처리 양식 다운'을 눌러 양식을 다운받아주세요.",
        "• 엑셀 편집 및 일괄등록 : 다운로드한 엑셀파일 내 상품주문번호, 개별상품주문번호, 택배사, 송장번호, 발송일, 수취인명을",
        "입력한 후 다시 업로드 하시면 일괄 등록 됩니다.",
        "• 엑셀 파일은 반드시 ‘Microsoft Excel 통합문서’ 양식으로 저장하셔야 합니다. 파일명은 임의로 저장해도 됩니다.",
        "• 엑셀 업로드 시 암호화를 해제하여 업로드 해주세요.",
        "• 유효성검사하기 : 등록 후 성공 및 실패 여부를 확인할 수 있으며, 등록 실패사유가 표시되며 확인 후 재업로드 하셔야 합니다.",
      ],
    },
  ];
  return (
    <Row
      className="content-header-wrap"
      style={
        subtitle || actionButton || breadcrumb
          ? {
              height: "auto",
              padding: "16px 25px",
              justifyContent: "space-between",
              alignItems: "center",
            }
          : {}
      }
    >
      <div>
        {breadcrumb && (
          <div className="content-header-breadcrumb">
            {breadcrumb.map((item, idx) => (
              <span key={idx}>
                {idx > 0 && (
                  <span className="content-header-breadcrumb__sep"> &gt; </span>
                )}
                <span
                  className={`content-header-breadcrumb__item${
                    idx === breadcrumb.length - 1
                      ? " content-header-breadcrumb__item--active"
                      : ""
                  }`}
                  onClick={item.onClick}
                  style={item.onClick ? { cursor: "pointer" } : {}}
                >
                  {item.label}
                </span>
              </span>
            ))}
          </div>
        )}
        <div
          className="content-header-title"
          style={subtitle || breadcrumb ? { color: "#0d1b2e" } : {}}
        >
          {title}
        </div>
        {subtitle && (
          <div style={{ fontSize: 13, color: "#8fa5bd", marginTop: 2 }}>
            {subtitle}
          </div>
        )}
      </div>
      {actionButton && (
        <Button
          onClick={actionButton.onClick}
          style={{
            background: "#1e6feb",
            color: "#ffffff",
            border: "none",
            borderRadius: 8,
            height: 36,
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {actionButton.label}
        </Button>
      )}
      {title === "발주확인/발송관리" && (
        <div className={`order-info-header-div`}>
          <Button
            className={`order-header-button`}
            onClick={() => setOrderModal(!orderModal)}
          >
            발주확인/발송처리 알아보기
          </Button>
          {orderModal && (
            <div className={`header-helper-wrap`}>
              <div className={`helper-header`}>
                <div className={`header-title`}>
                  <div className={`title-div`}>
                    <h3>발주확인/발송처리 안내</h3>
                  </div>
                  <img
                    onClick={() => setOrderModal(!orderModal)}
                    className={`close-button`}
                    alt={"닫기 버튼"}
                    src={`${process.env.REACT_APP_HOST}/assets/images/memberManage/close.png`}
                  />
                </div>
              </div>

              <div className={`helper-body`}>
                <p className={`info-title`}>
                  결제완료 > 발주확인 > 배송준비중 > 발주확인 > 배송중 >
                  배송완료
                </p>
                {orderInformation.map((item, idx) => (
                  <div className={`info-each`} key={`information-${idx}`}>
                    <p className={`each-title`}>{item.title}</p>
                    {item.content.map((content, index) => (
                      <p
                        className={`each-content`}
                        key={`information-each-${index}`}
                      >
                        {content}
                      </p>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </Row>
  );
};

export default ContentHeaderComponent;
